/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// reactstrap components
import { useAuth } from "context/AuthProvider";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Col,
} from "reactstrap";
import { apiLoginService } from "services/apiLoginService";
import { apiEmpleadosService } from "services/apiEmpleadosService";
import { showAppAlert } from "components/common/AppAlerts";
import Auth from "layouts/Auth";

const EMPLEADO_CACHE_TTL_MS = 24 * 60 * 60 * 1000;

const getEmpleadoCacheKey = (empresaId, empleadoId) =>
  `empleado_profile_${empresaId}_${empleadoId}`;

const readEmpleadoFromCache = (empresaId, empleadoId) => {
  const cacheKey = getEmpleadoCacheKey(empresaId, empleadoId);
  const raw = localStorage.getItem(cacheKey);
  if (!raw) {
    return null;
  }

  try {
    const parsed = JSON.parse(raw);
    const isExpired =
      !parsed?.cachedAt ||
      Date.now() - Number(parsed.cachedAt) > EMPLEADO_CACHE_TTL_MS;

    if (isExpired) {
      localStorage.removeItem(cacheKey);
      return null;
    }

    return {
      nombre: parsed?.nombre || null,
      apellidos: parsed?.apellidos || null,
    };
  } catch (error) {
    localStorage.removeItem(cacheKey);
    return null;
  }
};

const writeEmpleadoToCache = (empresaId, empleadoId, empleadoDetalle) => {
  const cacheKey = getEmpleadoCacheKey(empresaId, empleadoId);
  const payload = {
    nombre: empleadoDetalle?.nombre || null,
    apellidos: empleadoDetalle?.apellidos || null,
    cachedAt: Date.now(),
  };
  localStorage.setItem(cacheKey, JSON.stringify(payload));
};

const Login = () => {
   const navigate = useNavigate();
  const {Empleadologin } = useAuth();
  const [tenant, setTenant] = useState(localStorage.getItem("tenant") || "");
  const [usuario, setUsuario] = useState()


  

  const handleOnSubmit = async (e) =>{
    e.preventDefault()

    localStorage.setItem("tenant", tenant)

    const json = {
      empresaNombre: tenant,
      username: usuario,
      password: usuario
    }

    const responseLogin = await apiLoginService.postLoginUser(json);

    if(!responseLogin.ok ){
      let errorMessage = "Usuario o contrase�a no valido";
      try {
        const errorData = await responseLogin.json();
        errorMessage = errorData?.message || errorData?.error || errorMessage;
      } catch (error) {
        // Si no hay JSON en la respuesta, mantenemos el mensaje por defecto.
      }
      showAppAlert(errorMessage, "error")
      return;
    } 

    const responseJson = await responseLogin.json();


    if(responseJson.token !== "null" && responseJson.rol === "EMPLEADO"){
      localStorage.setItem("token", responseJson.token)
      localStorage.setItem("tenant_id", responseJson.empresaId)

      let empleadoDetalle = readEmpleadoFromCache(
        responseJson.empresaId,
        responseJson.empleadoId
      );
      if (!empleadoDetalle) {
        try {
          empleadoDetalle = await apiEmpleadosService.get(
            responseJson.empresaId,
            responseJson.empleadoId
          );
          writeEmpleadoToCache(
            responseJson.empresaId,
            responseJson.empleadoId,
            empleadoDetalle
          );
        } catch (error) {
          // Si falla la carga de detalle no bloqueamos el login.
        }
      }

      Empleadologin({
        id: responseJson.empleadoId,
        empresaId: responseJson.empresaId,
        token: responseJson.token,
        userId: responseJson.userId,
        nombre: empleadoDetalle?.nombre || null,
        apellidos: empleadoDetalle?.apellidos || null,
      })
      navigate("/user/index")
      
    }else{
      showAppAlert("Usuario no autorizado", "error")
    }


  }

  return (
    <>
    <Auth>
      <Col lg="5" md="7">
        <Card className="bg-secondary shadow border-0">
          <CardHeader className="bg-transparent  text-center">
            <h2>Acceso de empleado </h2>  
          </CardHeader>
          <CardBody className="">
            <div className="text-center text-muted mb-4">
              <small>Introduza sus credenciales</small>
            </div>
            <Form role="form" onSubmit={handleOnSubmit}>      
              <FormGroup>
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">   
                    <InputGroupText>
                      <i className="ni ni-building" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Empresa"
                    type="text"
                    value={tenant}
                    onChange={(e) => setTenant(e.target.value)}
                  />
                </InputGroup>
              </FormGroup>    
              <FormGroup className="mb-3">
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-circle-08" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Usuario"
                    type="text"
                    value={usuario}
                    onChange={(e) => setUsuario(e.target.value)}
                  />
                </InputGroup>
              </FormGroup>
      
            
              <div className="text-center">
                <Button className="my-4" color="primary" type="submit">
                  Iniciar sesión
                </Button>
              </div>
            </Form>
           
          </CardBody>
        </Card>
        
      </Col>
      </Auth>
    </>
  );
};

export default Login;



